class Map {
  mapOptions1 = {
    center: new google.maps.LatLng(47.1326029, 8.740855),
    zoom: 14,
    mapTypeControl: false,
    streetViewControl: false,
    draggable: true,
    scrollwheel: false,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
  };

  constructor($el) {
    console.log("init MAP");
    this.$el = $el;
    this.map = new google.maps.Map(this.$el[0], this.mapOptions1);
    this.map.set("styles", [
      {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{ color: "#444444" }],
      },
      {
        featureType: "landscape",
        elementType: "geometry.fill",
        stylers: [{ color: "#f2f2f2" }],
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road",
        elementType: "all",
        stylers: [{ saturation: -100 }, { lightness: 45 }],
      },
      {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "water",
        elementType: "all",
        stylers: [{ color: "#6EB2C9" }, { visibility: "on" }],
      },
    ]);

    const marker1 = new google.maps.Marker({
      map: this.map,
      position: new google.maps.LatLng(47.135423513021834, 8.746958530728255),
      draggable: false,
      clickable: true,
      icon: "upload/layout/Icons/marker.svg",
    });

    const marker2 = new google.maps.Marker({
      map: this.map,
      position: new google.maps.LatLng(47.12707956945002, 8.75102311179603),
      draggable: false,
      clickable: true,
      icon: "upload/layout/Icons/marker.svg",
    });

    const marker3 = new google.maps.Marker({
      map: this.map,
      position: new google.maps.LatLng(47.12687874462148, 8.752399693598633),
      draggable: false,
      clickable: true,
      icon: "upload/layout/Icons/marker.svg",
    });

    // info window
    const infoWindow1 = new google.maps.InfoWindow({
      content: `<p class="section__title">
									<a href="https://www.google.com/maps/place/Milchmanufaktur+Einsiedeln/@47.1352778,8.7447557,17z/data=!3m1!4b1!4m5!3m4!1s0x479ab4f12b48253b:0x4af0349347d14e66!8m2!3d47.1352778!4d8.7469444" target="_blank" rel="noopener noreferrer">
										Milchmanufaktur
									</a>
								</p>
									<div class="rich-text">
										<p>
											Alpstrasse 6,<br>
											8840 Einsiedeln
										</p>
									</div>`,
    });

    const infoWindow2 = new google.maps.InfoWindow({
      content: `<p class="section__title">
									<a href="https://www.google.com/maps/place/Arkaden+Milchmanufaktur+Laden/@47.1248625,8.7531881,15.04z/data=!4m5!3m4!1s0x479ab3557ee3090f:0x9d1a363afb117d94!8m2!3d47.1268825!4d8.7510553" target="_blank" rel="noopener noreferrer">
										Kloster Arkaden
									</a>
								</p>
									<div class="rich-text">
										<p>
											Klosterplatz,<br>
											8840 Einsiedeln
										</p>
									</div>`,
    });

    const infoWindow3 = new google.maps.InfoWindow({
      content: `<p class="section__title">
									<a href="https://www.google.com/maps/place/Gastwirtschaft+im+Abteihof/@47.1261705,8.7432528,15z/data=!4m5!3m4!1s0x0:0x85de6c2c165cfd27!8m2!3d47.1260391!4d8.7524581" target="_blank" rel="noopener noreferrer">
										Abteihof	
									</a>
								</p>
									<div class="rich-text">
										<p>
											Holzhofstrasse 2,<br>
											8840 Einsiedeln										
										</p>
									</div>`,
    });

    marker1.addListener("click", (e) => {
      infoWindow2.close();
      infoWindow3.close();

      infoWindow1.open({
        anchor: marker1,
        map: this.map,
        focus: true,
      });
    });

    marker2.addListener("click", (e) => {
      infoWindow1.close();
      infoWindow3.close();
      infoWindow2.open({
        anchor: marker2,
        map: this.map,
        focus: true,
      });
    });

    marker3.addListener("click", (e) => {
      infoWindow1.close();
      infoWindow2.close();
      infoWindow3.open({
        anchor: marker3,
        map: this.map,
        focus: true,
      });
    });
  }
}

export default Map;
